import {Resource} from "../../api/resource";
import {BasicEntity, BasicProperty} from "../../basic-entity-back/annotations";
import {PropertyType} from "../../basic-entity-back/property-type/property-type";
import {PropertyMap, ReadWrite} from "../../basic-entity-back/basic-entity-interface/mapping-external";
import {Archivo} from "./archivo.model";

@BasicEntity({
    name: 'Archivo',
    endpoint: 'archivo_blender_secundarias',
    isPaginated: true,
    paginationSizes: [20, 30, 50],
    type: "ArchivoBlenderSecundaria"
})
export class ArchivoBlenderSecundaria extends Archivo {
    public static readonly BLENDER_MAP: PropertyMap = {
        name: 'Blender Secundaria',
        type: PropertyType.FutureUri('blender-secundaria.model.ts'),
        readWrite: ReadWrite.ReadOnly
    }
    @BasicProperty(ArchivoBlenderSecundaria.BLENDER_MAP)
    private _blenderSecundaria;

    get blenderSecundaria() {
        return this._blenderSecundaria;
    }

    set blenderSecundaria(value) {
        this._blenderSecundaria = value;
    }
}
